const env = process.env.REACT_APP_LOG_LEVEL;

function gdebug(level,...args){
  if(+env >= level ) {
    console.log.apply(console, args);
  }
}
export { gdebug };